<template>
  <component
    :is="tag"
    :class="[textClass, hoverClass]"
    :style="textStyle"
    v-bind="$attrs"
    v-on="$listeners"
    @mouseenter="onEnableHover"
    @mouseleave="onDisableHover"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "TextField",
  props: {
    tag: {
      type: String,
      default: "span",
    },
    size: {
      type: [String, Number],
      default: 16,
    },
    weight: {
      type: [String, Number],
      default: "normal",
    },
    color: {
      type: String,
      default: "#000",
    },
    hoverColor: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: "left",
    },
    lineHeight: {
      type: [String, Number],
      default: 1.5,
    },
    letterSpacing: {
      type: [String, Number],
      default: "normal",
    },
    transform: {
      type: String,
      default: "none",
    },
    enableHover: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: "color 0.3s ease",
    },
  },
  data() {
    return {
      isHovered: false,
    };
  },
  computed: {
    textClass() {
      return {
        [`text-align-${this.align}`]: true,
      };
    },
    hoverClass() {
      return this.isHovered && this.hoverColor ? "hover-active" : "";
    },
    textStyle() {
      return {
        fontSize: typeof this.size === "number" ? `${this.size}px` : this.size,
        fontWeight: this.weight,
        color: this.isHovered && this.hoverColor ? this.hoverColor : this.color,
        lineHeight:
          typeof this.lineHeight === "number"
            ? this.lineHeight
            : `${this.lineHeight}`,
        letterSpacing:
          typeof this.letterSpacing === "number"
            ? `${this.letterSpacing}px`
            : this.letterSpacing,
        textTransform: this.transform,
        textAlign: this.align,
        transition: this.transition,
      };
    },
  },
  methods: {
    onEnableHover() {
      if (this.enableHover) {
        this.isHovered = true;
      }
    },
    onDisableHover() {
      if (this.enableHover) {
        this.isHovered = false;
      }
    },
  },
};
</script>

<style scoped>
.text-align-left {
  text-align: left;
}

.text-align-center {
  text-align: center;
}

.text-align-right {
  text-align: right;
}

.text-align-justify {
  text-align: justify;
}

.hover-active {
  cursor: pointer;
}
</style>
